import { Credential, CredentialEntity, Logger } from '@uploadcam/common';
import { RefreshCredentialAdapterInteractor } from '../../auth/domain/interactors/refresh-credential.interactor';

/**
 * Zoho credentials cannot be refreshed.
 *
 * Zoho's implicit grant issues no refresh_token. The only way to get a new access token is to
 * re-run the OAuth flow, and a silent (`prompt=none`) attempt needs a popup — browsers won't let
 * that popup be truly invisible (they enforce a minimum size and ignore off-screen coordinates),
 * so it flashes on screen. Rather than flash a popup on every ~1h token expiry, we treat an expired
 * Zoho token as an expired session: this throws, and the caller surfaces an in-app "session
 * expired" prompt that sends the user back to our main login screen. See docs/zoho-authentication.md.
 */
export class RefreshZohoCredentialInteractor implements RefreshCredentialAdapterInteractor {
  constructor(private readonly logger: Logger) {}

  public async execute(_credential: Credential): Promise<CredentialEntity> {
    this.logger.info('Zoho token expired and cannot be refreshed silently; prompting re-login.');
    throw new Error('Zoho credentials cannot be refreshed (implicit flow has no refresh token).');
  }
}
